import { SpotCheckbox, SpotCheckboxGroup } from '@enterprise/spot';
import { Row, Col } from 'react-bootstrap';
import { Field, FieldRenderProps } from 'react-final-form';
import { AnalyticsAccessEntity } from '../../../../core/entity/AnalyticsAccessEntity';

function AnalyticsFeatureAccessField({
    input,
    items,
    disabled = false,
}: FieldRenderProps<any> & { items: AnalyticsAccessEntity[]; disabled?: boolean }) {
    const value = (input.value as number[]) || [];

    const setIds = (next: number[]) => {
        ((input.onChange as unknown) as (v: number[]) => void)(next);
    };

    const toggle = (id: number, checked: boolean) => {
        if (disabled) {
            return;
        }
        if (checked) {
            setIds([...value, id]);
        } else {
            setIds(value.filter(x => x !== id));
        }
    };

    return (
        <>
            {items.map(item => (
                <Row key={item.id}>
                    <Col>
                        <SpotCheckbox
                            type="checkbox"
                            disabled={disabled}
                            checked={value.includes(item.id)}
                            onChange={event => toggle(item.id, (event.target as HTMLInputElement).checked)}
                            data-automation-id={`analyticsFeatureAccess-${item.id}`}
                        >
                            {item.name}
                        </SpotCheckbox>
                    </Col>
                </Row>
            ))}
        </>
    );
}

interface AnalyticsFeatureAccessCheckboxesProps {
    name: string;
    /** Catalog rows with `type === FEATURE_ACCESS`. */
    featureAccessItems: AnalyticsAccessEntity[];
    disabled?: boolean;
}

export const AnalyticsFeatureAccessCheckboxes = ({ name, featureAccessItems, disabled = false }: AnalyticsFeatureAccessCheckboxesProps) => (
    <SpotCheckboxGroup>
        <Field name={name} subscription={{ value: true }}>
            {(props: FieldRenderProps<any>) => (
                <AnalyticsFeatureAccessField {...props} items={featureAccessItems} disabled={disabled} />
            )}
        </Field>
    </SpotCheckboxGroup>
);
